import { BadgeCheck, MapPin, ShieldCheck, FileCheck } from "lucide-react";
import { WHY_CLARUS } from "@/content/copy";

const ICONS = { BadgeCheck, MapPin, ShieldCheck, FileCheck };

export default function WhyClarus() {
  return (
    <section data-testid="why-clarus-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{WHY_CLARUS.overline}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{WHY_CLARUS.title}</h2>
        </div>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 stagger">
          {WHY_CLARUS.items.map((item) => {
            const Icon = ICONS[item.icon];
            return (
              <div
                key={item.title}
                data-testid={`why-card-${item.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-2xl bg-background border border-border p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="w-11 h-11 rounded-xl bg-navy flex items-center justify-center">
                  <Icon className="w-5 h-5 text-terracotta" aria-hidden="true" />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-navy">{item.title}</h3>
                <p className="mt-2 text-sm text-navy/70 leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
